import { Theme } from '@mui/material/styles';
import { hexToRgb } from '~/theme';

const cardStyle = {
  card: {
    border: '0',
    color: (theme: Theme) => `rgba(${hexToRgb(theme.palette?.primary.main)}, 0.87)`,
    background: (theme: Theme) => theme.palette?.secondary.main,
    width: '100%',
    boxShadow: (theme: Theme) => `0 1px 4px 0 rgba(${hexToRgb(theme.palette?.primary.main)}, 0.14)`,
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    marginBottom: '10px',
    '@media (min-width: 600px)': {
      '&.stats': {
        minHeight: '140px',
        maxWidth: '400px',
      },
      '&.chart': {
        width: 'calc(100% - 20px)',
        maxWidth: '600px',
      },
      '&.table': {
        width: 'calc(100% - 20px)',
        maxWidth: '1230px',
      },
    },
  },
  stats: {
    '@media (min-width: 600px)': {
      minHeight: '140px',
      maxWidth: '400px',
    },
  },
} as const;

export default cardStyle;
